import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from './store';

// Define the shape of your state
interface ProjectCompanyState {
	projectId: number;
	companyId: number;
}

// Helper functions to read from localStorage
const getProjectId = (): number => {
	const stored = localStorage.getItem('projectId');
	return stored ? parseInt(stored, 10) : 0; // default to 0 if not set
};

const getCompanyId = (): number => {
	const stored = localStorage.getItem('companyId');
	return stored ? parseInt(stored, 10) : 0; // default to 0 if not set
};

const initialState: ProjectCompanyState = {
	projectId: getProjectId(),
	companyId: getCompanyId(),
};

export const projectCompanySlice = createSlice({
	name: 'projectCompany',
	initialState,
	reducers: {
		setProjectId: (state, action: PayloadAction<number>) => {
			state.projectId = action.payload;
			localStorage.setItem('projectId', action.payload.toString());
		},
		setCompanyId: (state, action: PayloadAction<number>) => {
			state.companyId = action.payload;
			localStorage.setItem('companyId', action.payload.toString());
		},
		// Optionally, a reducer to update both together:
		setProjectCompany: (
			state,
			action: PayloadAction<{ projectId: number; companyId: number }>,
		) => {
			state.projectId = action.payload.projectId;
			state.companyId = action.payload.companyId;
			localStorage.setItem('projectId', action.payload.projectId.toString());
			localStorage.setItem('companyId', action.payload.companyId.toString());
		},
		clearProjectCompany: (state) => {
			state.projectId = 0;
			state.companyId = 0;
			localStorage.removeItem('projectId');
			localStorage.removeItem('companyId');
		},
	},
});

// Export the actions
export const { setProjectId, setCompanyId, setProjectCompany, clearProjectCompany } = projectCompanySlice.actions;

// Export selectors
export const selectProjectId = (state: RootState) => state.projectCompany.projectId;
export const selectCompanyId = (state: RootState) => state.projectCompany.companyId;

export default projectCompanySlice.reducer;
